<template>
  <div>
    <!-- <rabbey-toolbox
      filter-placeholder="Buscar por nombre"
      filterables
      @filter-search="search = $event"
    /> -->
    <el-row>
      <el-col class="space" :span="6"
        ><el-select
          v-if="options"
          v-model="year"
          size="mini"
          placeholder="años"
          clearable
          filterable
          @change="handlerYearChange"
          class="amountSelect"
        >
          <el-option
            v-for="year in yearsearch"
            :key="year"
            :label="year"
            :value="year"
          >
          </el-option>
        </el-select>

        <!-- <el-select
          v-else
          v-model="declinedOption"
          size="mini"
          :loading="loading_transaction_report"
          filterable
          clearable
          placeholder="Filtro declinadas"
          @change="onDeclinedChanging"
          class="supliers_select"
        >
          <el-option
            v-for="(item, index) in declinedOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option
        ></el-select> -->
      </el-col>

      <el-col :span="6"
        ><el-select
          v-if="options"
          v-model="month"
          size="mini"
          placeholder="mes"
          clearable
          filterable
          @change="handlerMonthChange"
          class="amountSelect"
        >
          <el-option
            v-for="month in this.monthNames"
            :key="month.value"
            :label="month.value"
            :value="month.key"
          >
          </el-option>
        </el-select>

        <!-- <el-select
          v-else
          v-model="declinedOption"
          size="mini"
          :loading="loading_transaction_report"
          filterable
          clearable
          placeholder="Filtro declinadas"
          @change="onDeclinedChanging"
          class="supliers_select"
        >
          <el-option
            v-for="(item, index) in declinedOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option
        ></el-select> -->
      </el-col>
    </el-row>
    <el-card class="box-card">
      <el-tabs v-model="activeName" @tab-click="switchtabs">
        <el-tab-pane label="Tickets Por Dias" name="dia">
          <rabbey-table3
            ref="dia"
            :border="true"
            :stripe="true"
            :columns="ColumnsTicketDay"
            v-loading="loading1"
            :data="dataApi"
            :paginateFromApi="true"
            :pageSizes="[10, 20, 50, 100, 200, 500]"
            :paginationApi="Paginacion"
            @update-current-page="this.changeCurrentPage"
            @update-page-size="this.changeCurrentPageSize"
          />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import { ColumnsTicketDay } from "./columnsTables/TicketsColumn.js";
import { Columns } from "./columnsTables/TransactionReportColumns";

export default {
  name: "TicketsReport",

  //   created: async function () {
  //     this.$store.dispatch("getTransactionReport");
  //   },

  computed: {
    getMonth() {
      let today = new Date(Date.now());
      let currentMonth = {
        value: new Intl.DateTimeFormat("es-US", { month: "long" }).format(
          Date.now()
        ),
        key: today.getMonth() + 1
      };

      return currentMonth;
    },

    yearsearch() {
      // const lowerYear = 2014;
      const currentYear = new Date().getFullYear();
      let Years = [];
      for (var i = 20; i >= 0; i--) {
        Years.unshift(currentYear - i);
      }

      return Years;
    },
    Paginacion() {
      return {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        total: this.total
      };
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 100,
      activeName: "TicketsReport",
      dataApi: [],
      year: new Date().getFullYear(),
      monthForApi: new Date(Date.now()).getMonth() + 1,
      month: new Intl.DateTimeFormat("es-US", { month: "long" }).format(
        Date.now()
      ),
      monthNames: [
        { value: "Enero", key: 1 },
        { value: "Febrero", key: 2 },
        { value: "Marzo", key: 3 },
        { value: "Abril", key: 4 },
        { value: "Mayo", key: 5 },
        { value: "Junio", key: 6 },
        { value: "Julio", key: 7 },
        { value: "Agosto", key: 8 },
        { value: "Septiembre", key: 9 },
        { value: "Octubre", key: 10 },
        { value: "Noviembre", key: 11 },
        { value: "Diciembre", key: 12 }
      ],

      options: "",
      loading1: false,
      declinedOption: null,

      Columns,
      ColumnsTicketDay,
      search: "",
      declined: null,
      newOption: null
    };
  },

  methods: {
    changeCurrentPageSize(value) {
      this.pageSize = value;
      this.GetTicketAumount();
    },

    changeCurrentPage(value) {
      this.currentPage = this.currentPage = value;
      this.GetTicketAumount();
    },
    GetTicketAumount() {
      this.loading1 = true;
      this.$http
        .get(
          `/api/tennos/GetTicketsByDay?RecordsPerPage=${this.pageSize}&page=${this.currentPage}&year=${this.year}&Month=${this.monthForApi}`
        )
        .then((resp) => {
          this.dataApi = resp.data.tickets;
          this.total = resp.data.cantidad;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading1 = false;
        });
    },

    handlerYearChange(year) {
      this.year = year;
      this.GetTicketAumount();
    },
    handlerMonthChange(month) {
      this.monthForApi = month;
      this.GetTicketAumount();
    },
    switchtabs(activeName) {
      switch (activeName.name) {
        case "cl": {
          this.options = "cl";
          this.GetTicketAumount();
          break;
        }
        case "pr": {
          this.options = "pr";
          this.GetTicketAumount();
          break;
        }
        case "tr": {
          this.options = "tr";
          this.GetTicketAumount();
          break;
        }

        case "dia": {
          this.options = "dia";
          this.GetTicketAumount();
          break;
        }
        case "hor": {
          this.options = "hor";
          this.GetTicketAumount();
          break;
        }
        case "min": {
          this.options = "min";
          this.GetTicketAumount();
          break;
        }
      }
    }
  }
};
</script>

<style scoped>
.amountSelect {
  position: relative;
  left: 5px;
  top: 5px;
}
.space {
  width: 10%;
}
</style>
